import React from 'react';
import { SingleSelectMenu } from '../Dropdown';
import { FieldLabel, VerticalField } from '../Form';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 4px;
  font-weight: 500;
`;

interface IProps {
  alertOnly: boolean;
  setAlertOnly: (newvalue: boolean) => void;
}

const OPTIONS = [
  { text: 'Always', value: 'false' },
  { text: 'Alert Only', value: 'true' },
];

export default ({ alertOnly, setAlertOnly }: IProps) => {
  return (
    <VerticalField>
      <Wrapper>
        <FieldLabel>When do you want to be notified?</FieldLabel>
        <SingleSelectMenu
          options={OPTIONS}
          value={alertOnly ? 'true' : 'false'}
          onChange={(nv) => setAlertOnly(nv === 'true')}
        />
      </Wrapper>
    </VerticalField>
  );
};
